import { Module } from 'vuex';
import store, { IRootState } from './store';
import restService from '@/services/restService';

export interface IUserState {
  userProfile: IUserProfile | null;
  profiles: IUserProfile[];
  userProfileGroups: IGroupUserProfile[];
}

const userState: IUserState = {
    userProfile: null,
    profiles: [],
    userProfileGroups: [],
};

const userGetters = {

};

const userMutations = {
  setUserProfile: (state: IUserState, profile: IUserProfile) => {
    state.userProfile = profile;
    const profileIndex = state.profiles.findIndex(p => p.userId === profile.userId);
    profileIndex > -1 ? state.profiles.splice(profileIndex, 1, profile) : state.profiles.push(profile);
  },
  setProfiles: (state: IUserState, profiles: IUserProfile[]) => state.profiles = profiles,
  setUserProfileGroups: (state: IUserState, groups: IGroupUserProfile[]) => state.userProfileGroups = groups,
  removeFromProfiles: (state: IUserState, profile: IUserProfile) => {
    const profileIndex = state.profiles.findIndex(p => p.userId === profile.userId);
    if (profileIndex > -1) {
      state.profiles.splice(profileIndex, 1);
    }
  },
};

const userActions = {
  async getProfiles({ commit }: {commit: any}) {
    const profiles = await restService.userProfile.getProfiles();
    commit('setProfiles', profiles);
  },
  async getUserProfile({ dispatch, commit, rootState }: { dispatch: any, commit: any, rootState: IRootState }) {
    if (rootState.auth.profile) {
      const userProfile = await restService.userProfile.getUserProfile(rootState.auth.profile.id);
      commit('setUserProfile', userProfile);
      await dispatch('getUserProfileGroups');
    }
  },
  async getUserProfileGroups({ commit, rootState }: { commit: any, rootState: IRootState }) {
    if (rootState.user.userProfile) {
      const groups = await restService.userProfile.getUserProfileGroups(rootState.user.userProfile.id);
      commit('setUserProfileGroups', groups);
    } else {
      commit('setUserProfileGroups', []);
    }
  },
  async deleteProfile({ commit }: { commit: any }) {
    const resetProfile = await restService.userProfile.deleteUserProfile();
    commit('setUserProfile', resetProfile);
    commit('removeFromProfiles', store.state.user.userProfile);
  },
};

const userStore: Module<IUserState, IRootState> = {
  namespaced: true,
  state: userState,
  getters: userGetters,
  mutations: userMutations,
  actions: userActions,
};
export default userStore;
